import React, { useEffect, useState } from 'react';
import './OpenInBrowserPrompt.css';
import whiteLogo from '../../../../assets/logo_white.png';

const OpenInBrowserPrompt = () => {
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isStandardBrowser =
      ua.includes('Chrome') ||
      ua.includes('Safari') ||
      ua.includes('Firefox') ||
      ua.includes('Edg') ||
      ua.includes('Opera');

    setIsInAppBrowser(!isStandardBrowser);
    setLoading(false);
  }, []);

  if (loading || !isInAppBrowser) return null;

  const handleOpenInBrowser = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const url = 'https://www.pawsible.app';

    if (/android/i.test(ua)) {
      // Android → Chrome intent
      window.location.href =
        'intent://www.pawsible.app#Intent;scheme=https;package=com.android.chrome;end;';
      return;
    }

    // iOS + everything else
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText('https://www.pawsible.app')
      .then(() => alert('Link copied! Open it in your browser.'))
      .catch(() => alert('Failed to copy link.'));
  };

  return (
    <div className="open-browser-prompt">
      <img
        src={whiteLogo}
        alt="Pawsible Logo"
        className="browser-prompt-logo"
      />

      <h2>Open in Browser</h2>

      <p>
        You’re viewing this page inside an in-app browser.
        For the best experience, open Pawsible in your browser.
      </p>

      <button
        className="open-browser-primary"
        onClick={handleOpenInBrowser}
      >
        Open
      </button>

      <button
        className="open-browser-secondary"
        onClick={handleCopyLink}
      >
        Copy Link
      </button>
    </div>
  );
};

export default OpenInBrowserPrompt;
